/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Import_Library_ItemsInputs */

const en_zotero_import_library_items = /** @type {(inputs: Zotero_Import_Library_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import items from your library`)
};

const es_zotero_import_library_items = /** @type {(inputs: Zotero_Import_Library_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa elementos de tu biblioteca`)
};

/**
* | output |
* | --- |
* | "Import items from your library" |
*
* @param {Zotero_Import_Library_ItemsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_import_library_items = /** @type {((inputs?: Zotero_Import_Library_ItemsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Import_Library_ItemsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_import_library_items(inputs)
	return en_zotero_import_library_items(inputs)
});